export default "__VITE_ASSET__CkJOPHrI__"